import { dom } from './dom.js';

export function updateSliderDisplay(rawValue) {
    const val = parseFloat(rawValue);
    let displayDist;
    if (val <= 15) {
        displayDist = 15 - val;
        dom.sliderSubLabelLeft.className = 'text-xs mt-1 px-1 font-bold text-yellow-400';
        dom.sliderSubLabelRight.className = 'text-xs mt-1 px-1 font-medium text-gray-500';
    } else {
        displayDist = val - 15;
        dom.sliderSubLabelLeft.className = 'text-xs mt-1 px-1 font-medium text-gray-500';
        dom.sliderSubLabelRight.className = 'text-xs mt-1 px-1 font-bold text-yellow-400';
    }
    dom.sliderValueDisplay.textContent = `${displayDist.toFixed(1)} NM`;
}
